<template>
  <div class="setting-convert">
    <SettingCard :is-open="isOpened" :is-password="true" @accordion="accordionToggle" @save="onClickSave">
      <template v-slot:title>
        コンバート指示設定
      </template>
      <template v-slot:notice>
        一覧に表示するコンバート指示ボタンの表示非表示の設定ができます。設定の変更には管理者パスワードが必要です。
      </template>

      <template v-slot:contents>
        <div>
          <p>一覧に表示したいコンバート指示ボタンの表示設定を行います。</p>
          <ul class="list">
            <li>・表示したいポータルサイト名にチェックをしてください。</li>
            <li>
              ・自店舗以外の店舗も表示できます。他店舗の場合「閲覧のみ」にチェックするとコンバート状況のみ確認できるようになります。
            </li>
          </ul>

          <div>
            <template v-if="convertSettings && convertSettings.length > 0">
              <div v-for="(item, itemIdx) in convertSettings" :key="itemIdx" class="site-list">
                <div class="site-title">
                  <div class="shop_name">{{ item.shop_name }}</div>
                  <div>
                    <CheckboxBtn v-show="!item.self_store" label="閲覧のみ" :value.sync="item.read_only" />
                    <i-checkbox
                      v-model="item.all_checked"
                      :true-value="1"
                      :false-value="0"
                      size="small"
                      @on-change="onChangeAllCheck(item)"
                    >
                      全てにチェックする
                    </i-checkbox>
                  </div>
                </div>

                <template v-for="(site, siteIdx) in item.portalsites">
                  <CheckboxBtn
                    :key="siteIdx"
                    :label="site.label"
                    :value.sync="site.checked"
                    style="margin-bottom: 8px;"
                  />
                </template>
              </div>
            </template>
          </div>
        </div>
      </template>
    </SettingCard>
    <ModalPassword :modal.sync="modalPassword" @authentication="afterAuth" />
  </div>
</template>

<script>
import { Checkbox } from 'view-design'
import SettingCard from '@/components/parts/SettingCard'
import CheckboxBtn from '@/components/parts/CheckboxBtn'
import ModalPassword from '@/components/templates/modal/Password'
import SettingRepository from '@/repositories/settingRepository'
export default {
  components: {
    'i-checkbox': Checkbox,
    SettingCard,
    CheckboxBtn,
    ModalPassword,
  },
  props: {
    type: {
      type: String,
      default: '',
      required: true,
      validator: function(value) {
        return ['investment', 'residence'].indexOf(value) !== -1
      },
    },
  },
  data() {
    return {
      isOpened: false,
      modalPassword: false,
      convertSettings: [],
    }
  },
  computed: {},
  methods: {
    accordionToggle: function() {
      if (!this.isOpened) {
        this.modalPassword = true
      } else {
        this.isOpened = false
        this.resetParams()
      }
    },
    // 認証後の処理
    afterAuth() {
      this.getConvertInstructions()
    },
    // コンバート指示設定を取得する
    async getConvertInstructions() {
      this.$store.dispatch('Loading/setLoading', true)
      await SettingRepository.getConvertInstructions(this.type)
        .then(data => {
          if (data.result) {
            this.convertSettings = data.data
            this.isOpened = true
          } else {
            alert('コンバート指示設定の取得に失敗しました。')
          }
        })
        .catch(e => {
          console.log(e)
          alert('コンバート指示設定の取得に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // サイト毎の全てにチェックする 処理
    onChangeAllCheck(data) {
      let value = data.all_checked ? 1 : 0
      _.forEach(data.portalsites, function(site) {
        site.checked = value
      })
    },
    // サイト設定登録処理
    async onClickSave() {
      this.$store.dispatch('Loading/setLoading', true)
      await SettingRepository.putConvertInstructions(this.convertSettings, this.type)
        .then(data => {
          if (data.result) {
            alert('コンバート指示設定を更新しました。')
          } else {
            alert('コンバート指示設定の更新に失敗しました。')
          }
        })
        .catch(e => {
          console.log(e)
          alert('コンバート指示設定の更新に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // パラメーターリセット
    resetParams() {
      this.convertSettings = []
    },
  },
}
</script>

<style lang="scss" scoped>
.setting-convert {
  .list {
    list-style: none;
    margin-bottom: 16px;
  }
  .site-list {
    margin-bottom: 24px;
    .container {
      position: relative;
      min-height: 200px;
    }
    .site-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 2px;
      margin-bottom: 8px;
      border-bottom: 1px solid #cfcfcf;
    }
    .shop_name {
      font-weight: bold;
    }
    .table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      margin-bottom: 0;
      th {
        text-align: left;
      }
      td {
        padding: 4px 0;
      }
    }
    .error {
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      color: #f00;
    }
  }
  .text {
    margin-bottom: 8px;
  }
  .notice {
    margin-bottom: 24px;
    color: #f00;
  }
  .no_data {
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
}
</style>
